
import { CallScheduleBlacklistPage } from "pages/call-schedule-blacklist/CallScheduleBlacklistPage";
import ListCodedValues from "pages/coded-values/ListCodedValues";
import CSVGenericPage from "pages/csv/CSVGenericPage";
import ListCustomerFlags from "pages/customer-flags/ListCustomerFlags";
import ListDashboardLayoutsPage from "pages/dashboard-layouts/ListDashboardLayoutsPage";
import ViewDashboardLayoutPage from "pages/dashboard-layouts/ViewDashboardLayoutPage";
import DistributionPage from "pages/distribution/DistributionPage";
import FormEditor from "pages/forms/manager/FormEditor";
import FormEditorV2 from "pages/forms/manager/FormEditorV2";
import { ListFormsPage } from "pages/forms/manager/ListFormsPage";
import HierarchiesPage from "pages/hierarchies/HierarchiesPage";
import ViewHierarchyPage from "pages/hierarchies/ViewHierarchyPage";
import ResourceImageManagerPage from "pages/image-management/ResourceImageManagerPage";
import { ListMasterTagsPage } from "pages/master-tags/list/ListMasterTagsPage";
import { ListMustSellSkuPage } from "pages/must-sell-skus/list/ListMustSellSkuPage";
import { ViewMustSellPage } from "pages/must-sell-skus/view/ViewMustSellPage";
import CreateObjectivePage from "pages/objectives/create/CreateObjectivePage";
import { ListObjectivesPage } from "pages/objectives/list/ListObjectivesPage";
import ViewObjectivePage from "pages/objectives/view/ViewObjectivePage";
import OrderManagerPage from "pages/order-manager/OrderManagerPage";
import ListOutOfStockPage from "pages/out-of-stock/ListOutOfStockPage";
import ViewOutOfStockPage from "pages/out-of-stock/ViewOutOfStockPage";
import ListPriceListsPage from "pages/price-lists/ListPriceListsPage";
import ViewPriceListPage from "pages/price-lists/ViewPriceListPage";
import ProductAvailabilityPage from "pages/product-availability/ProductAvailabilityPage";
import { ListCategoriesPage } from "pages/product-categories/list/ListCategoriesPage";
import { ViewCategoryPage } from "pages/product-categories/view/ViewCategoryPage";
import { ListProductGroupingsPage } from "pages/product-groupings/list/ListProductGroupingsPage";
import { ViewProductGroupingPage } from "pages/product-groupings/view/ViewProductGroupingPage";
import { ListProductsPage } from "pages/products/list/ListProductsPage";
import { ViewProductPage } from "pages/products/view/ViewProductPage";
import ListRoutesPage from "pages/routes/list/ListRoutesPage";
import { ViewRoutePage } from "pages/routes/view/ViewRoutePage";
import { CampaignsPage } from "pages/targeting/campaigns/CampaignsPage";
import { ListCampaignsPage } from "pages/targeting/campaigns/ListCampaignsPage";
import { ViewCampaignPage } from "pages/targeting/campaigns/ViewCampaignPage";
import ListContentPage from "pages/targeting/content/ListContentPage";
import ViewContentPage from "pages/targeting/content/ViewContentPage";
import ListTargetGroupsPage from "pages/targeting/targets/ListTargetGroupsPage";
import ViewTargetGroupsPage from "pages/targeting/targets/ViewTargetGroupsPage";
import ListUserRolesPage from "pages/user-roles/ListUserRolesPage";
import ViewUserRolesPage from "pages/user-roles/ViewUserRolesPage";
import ViewUserPage from "pages/users/user/ViewUserPage";
import UsersPage from "pages/users/UsersPage";
import { getCSVType } from "state/constants/CSVType";
import { TargetGroupType } from "state/constants/TargetGroupTypes";
import { FixMeLater } from "types/FixMeLaterType";
import i18n from "./i18n";
import { UserRoles } from "./state/constants/UserRoles";


type PagesConfig = Readonly<{ [index: string]: Page }>

interface Page {
    icon?: string | undefined
    name: string
    route: string
    type: string
    roles: string[]
    flavours: string[],
    component?: FixMeLater | undefined
    children?: { [index: string]: PageChild } | undefined
    csvUrlOverride?: { get: string, post: string } | undefined,
    // CSV page type
    pageType?: { key: string, apiType: string, title: string } | string | undefined,
    exact?: boolean | undefined
}

interface PageChild {
    icon?: string | undefined
    route: string
    roles: string[]
    flavours: string[],
    component: FixMeLater,
    // Target group page type
    pageType?: string | undefined,
    exact?: boolean | undefined
}

export const PagesConfig = (): PagesConfig => {
    const { COMMERICAL, IT_ADMIN, DISTRIBUTOR } = UserRoles
    const SIMA = "SIMA"
    const VN = "VN"
    const PH = "PH"
    const CONA = "CONA"
    const csvTypes = getCSVType()

    const config = Object.freeze({
        home: {
            icon: "home.svg",
            name: i18n.t("home.home"),
            route: "/",
            type: "link",
            exact: true,
            roles: new Array<string>(),
            flavours: new Array<string>()
        },
        routeManagementHeader: {
            name: i18n.t("drawer-items.route-management"),
            type: "header",
            route: "route-manage-header",
            roles: [COMMERICAL, IT_ADMIN, DISTRIBUTOR],
            flavours: new Array<string>()
        },
        routes: {
            icon: "seo-consulting.svg",
            name: i18n.t("route.routes"),
            route: "/routes",
            type: "link",
            exact: true,
            roles: [COMMERICAL, IT_ADMIN],
            flavours: new Array<string>(),
            component: ListRoutesPage,
            children: {
                routesView: {
                    route: "/:routeId",
                    roles: [IT_ADMIN, COMMERICAL],
                    flavours: new Array<string>(),
                    component: ViewRoutePage
                }
            }
        },
        routeUserAssignment: {
            icon: "cloud-upload.svg",
            name: i18n.t("route.route-assignment"),
            route: "/routes-user-upload",
            type: "link",
            exact: true,
            roles: [COMMERICAL, IT_ADMIN],
            flavours: new Array<string>(),
            component: CSVGenericPage,
            csvUrlOverride: { get: "users/routes/download", post: "users/routes/upload" },
            pageType: csvTypes.USER_ROUTES
        },
        users: {
            icon: "users.svg",
            name: i18n.t("user.users"),
            route: "/users",
            type: "link",
            exact: true,
            roles: [COMMERICAL, IT_ADMIN],
            flavours: new Array<string>(),
            component: UsersPage,
            children: {
                usersView: {
                    route: "/:userId",
                    roles: [IT_ADMIN, COMMERICAL],
                    flavours: new Array<string>(),
                    component: ViewUserPage
                }
            }
        },
        userRoles: {
            icon: "brick.svg",
            name: i18n.t("user-role.user-roles"),
            route: "/user-roles",
            type: "link",
            exact: true,
            roles: [COMMERICAL, IT_ADMIN],
            flavours: new Array<string>(),
            component: ListUserRolesPage,
            children: {
                userRolesView: {
                    route: "/:userRoleId",
                    roles: [COMMERICAL, IT_ADMIN],
                    flavours: new Array<string>(),
                    component: ViewUserRolesPage
                }
            }
        },
        distributors: {
            icon: "network.svg",
            name: i18n.t("distributor.distributors"),
            route: "/distributors",
            type: "link",
            exact: true,
            roles: [IT_ADMIN],
            flavours: new Array<string>(),
            component: ListTargetGroupsPage,
            pageType: TargetGroupType.DISTRIBUTOR,
            children: {
                distributorsNew: {
                    route: "/new",
                    exact: true,
                    roles: [IT_ADMIN],
                    flavours: new Array<string>(),
                    component: ViewTargetGroupsPage,
                    pageType: TargetGroupType.DISTRIBUTOR
                },
                distributorsView: {
                    route: "/:targetGroupId",
                    roles: [IT_ADMIN],
                    flavours: new Array<string>(),
                    component: DistributionPage
                }
            },
        },
        hierarchies: {
            icon: "ux.svg",
            name: i18n.t("hierarchy.hierarchies"),
            route: "/hierarchies",
            type: "link",
            exact: true,
            roles: [IT_ADMIN],
            flavours: new Array<string>(),
            component: HierarchiesPage,
            children: {
                hierarchiesView: {
                    route: "/:hierarchyId",
                    roles: [IT_ADMIN],
                    flavours: new Array<string>(),
                    component: ViewHierarchyPage
                }
            }
        },
        customerFlags: {
            icon: "flag.svg",
            name: i18n.t("customer-flag.customer-flags"),
            route: "/customer-flags",
            type: "link",
            exact: true,
            roles: [IT_ADMIN],
            flavours: new Array<string>(),
            component: ListCustomerFlags
        },
        productManagementHeader: {
            name: i18n.t("drawer-items.product-management"),
            type: "header",
            route: "product-manage-header",
            roles: [COMMERICAL, IT_ADMIN],
            flavours: new Array<string>()
        },
        allProducts: {
            icon: "products.svg",
            name: i18n.t("product-group.all-products"),
            route: "/product-groupings/all-products",
            type: "link",
            exact: true,
            roles: [IT_ADMIN],
            flavours: new Array<string>(),
            component: ViewProductGroupingPage
        },
        empties: {
            icon: "empties.svg",
            name: i18n.t("product-group.empties"),
            route: "/product-groupings/empties",
            type: "link",
            exact: true,
            roles: [IT_ADMIN],
            flavours: new Array<string>(),
            component: ViewProductGroupingPage
        },
        tradeReturns: {
            icon: "returns.svg",
            name: i18n.t("product-group.trade-returns"),
            route: "/product-groupings/trade-returns",
            type: "link",
            exact: true,
            roles: [IT_ADMIN],
            flavours: new Array<string>(),
            component: ViewProductGroupingPage
        },
        samples: {
            icon: "samples.svg",
            name: i18n.t("product-group.samples"),
            route: "/product-groupings/samples",
            type: "link",
            exact: true,
            roles: [IT_ADMIN],
            flavours: new Array<string>(),
            component: ViewProductGroupingPage
        },
        products: {
            icon: "diamond.svg",
            name: i18n.t("product.products"),
            route: "/products",
            type: "link",
            exact: true,
            roles: [COMMERICAL, IT_ADMIN],
            flavours: new Array<string>(),
            component: ListProductsPage,
            children: {
                productsView: {
                    route: "/:productId",
                    roles: [COMMERICAL, IT_ADMIN],
                    flavours: new Array<string>(),
                    component: ViewProductPage
                }
            }
        },
        productGroups: {
            icon: "grid-alt.svg",
            name: i18n.t("product-group.product-groups"),
            route: "/product-groupings",
            type: "link",
            exact: true,
            roles: [COMMERICAL, IT_ADMIN],
            flavours: new Array<string>(),
            component: ListProductGroupingsPage,
            children: {
                productGroupsView: {
                    route: "/:productGroupId",
                    roles: [COMMERICAL, IT_ADMIN],
                    flavours: new Array<string>(),
                    component: ViewProductGroupingPage
                }
            }
        },
        categories: {
            icon: "layers.svg",
            name: i18n.t("category.categories"),
            route: "/categories",
            type: "link",
            exact: true,
            roles: [COMMERICAL, IT_ADMIN],
            flavours: new Array<string>(),
            component: ListCategoriesPage,
            children: {
                categoriesView: {
                    route: "/:categoryId",
                    roles: [COMMERICAL, IT_ADMIN],
                    flavours: new Array<string>(),
                    component: ViewCategoryPage
                }
            }
        },
        masterTags: {
            icon: "tag.svg",
            name: i18n.t("master-tag.master-tags"),
            route: "/tags",
            type: "link",
            exact: true,
            roles: [COMMERICAL, IT_ADMIN],
            flavours: new Array<string>(),
            component: ListMasterTagsPage
        },
        mustSell: {
            icon: "bolt.svg",
            name: i18n.t("must-sell.must-sell"),
            route: "/must-sell-skus",
            type: "link",
            exact: true,
            roles: [COMMERICAL, IT_ADMIN],
            flavours: new Array<string>(),
            component: ListMustSellSkuPage,
            children: {
                mustSellView: {
                    route: "/:mustSellSkuId",
                    roles: [COMMERICAL, IT_ADMIN],
                    flavours: new Array<string>(),
                    component: ViewMustSellPage
                }
            }
        },
        oosLists: {
            icon: "checkbox.svg",
            name: i18n.t("oos.oos-lists"),
            route: "/out-of-stock",
            type: "link",
            exact: true,
            roles: [IT_ADMIN, DISTRIBUTOR],
            flavours: new Array<string>(),
            component: ListOutOfStockPage,
            children: {
                oosView: {
                    route: "/:oosId",
                    roles: [DISTRIBUTOR, IT_ADMIN],
                    flavours: new Array<string>(),
                    component: ViewOutOfStockPage
                }
            }
        },
        productPricingHeader: {
            name: i18n.t("drawer-items.product-pricing"),
            type: "header",
            route: "product-pricing-header",
            roles: [COMMERICAL, IT_ADMIN],
            flavours: new Array<string>()
        },
        priceLists: {
            icon: "dollar.svg",
            name: i18n.t("price-list.price-lists"),
            route: "/price-lists",
            type: "link",
            exact: true,
            roles: [COMMERICAL, IT_ADMIN],
            flavours: new Array<string>(),
            component: ListPriceListsPage,
            children: {
                priceListNew: {
                    route: "/create",
                    exact: true,
                    roles: [COMMERICAL, IT_ADMIN],
                    flavours: new Array<string>(),
                    component: ViewPriceListPage
                },
                priceListView: {
                    route: "/:priceListId",
                    roles: [COMMERICAL, IT_ADMIN],
                    flavours: new Array<string>(),
                    component: ViewPriceListPage
                }
            }
        },
        formManagementHeader: {
            name: i18n.t("drawer-items.form-management"),
            type: "header",
            route: "form-manage-header",
            roles: [IT_ADMIN, COMMERICAL],
            flavours: new Array<string>()
        },
        forms: {
            icon: "forms.svg",
            name: i18n.t("form.forms"),
            route: "/forms",
            type: "link",
            exact: true,
            roles: [IT_ADMIN, COMMERICAL],
            flavours: new Array<string>(),
            component: ListFormsPage,
            children: {
                formsNew: {
                    route: "/new",
                    exact: true,
                    roles: [IT_ADMIN, COMMERICAL],
                    flavours: new Array<string>(),
                    component: FormEditorV2
                },
                formsEdit: {
                    route: "/edit/:formId",
                    roles: [IT_ADMIN, COMMERICAL],
                    flavours: new Array<string>(),
                    component: FormEditor
                },
            }
        },
        objectivesMangementHeader: {
            name: i18n.t("drawer-items.objective-management"),
            type: "header",
            route: "objectives-manage-header",
            roles: [IT_ADMIN, COMMERICAL],
            flavours: new Array<string>()
        },
        objectives: {
            icon: "write.svg",
            name: i18n.t("objective.objectives"),
            route: "/objectives",
            type: "link",
            exact: true,
            roles: [IT_ADMIN, COMMERICAL],
            flavours: new Array<string>(),
            component: ListObjectivesPage,
            children: {
                objectiveNew: {
                    route: "/new",
                    exact: true,
                    roles: [IT_ADMIN, COMMERICAL],
                    flavours: new Array<string>(),
                    component: CreateObjectivePage
                },
                objectiveView: {
                    route: "/:objectiveId",
                    roles: [IT_ADMIN, COMMERICAL],
                    flavours: new Array<string>(),
                    component: ViewObjectivePage
                },
            }
        },
        analyticsHeader: {
            name: i18n.t("drawer-items.analytics"),
            type: "header",
            route: "analytics-header",
            roles: [COMMERICAL, IT_ADMIN],
            flavours: new Array<string>()
        },
        orderManager: {
            icon: "agenda.svg",
            name: i18n.t("order-manager.order-manager"),
            route: "/order-manager",
            type: "link",
            exact: true,
            roles: [COMMERICAL, IT_ADMIN],
            flavours: new Array<string>(),
            component: OrderManagerPage
        },
        productAvailability: {
            icon: "support.svg",
            name: i18n.t("product-availability.product-availability"),
            route: "/product-availability",
            type: "link",
            exact: true,
            roles: [IT_ADMIN],
            flavours: new Array<string>(),
            component: ProductAvailabilityPage
        },
        dataManagementHeader: {
            name: i18n.t("drawer-items.data-management"),
            type: "header",
            route: "data-manager-header",
            roles: [COMMERICAL, IT_ADMIN],
            flavours: new Array<string>()
        },

        dashboard: {
            icon: "dashboard.svg",
            name: i18n.t('dashboard-layout.dashboard-layouts'),
            route: "/dashboard-layouts",
            type: "link",
            exact: true,
            roles: [IT_ADMIN],
            flavours: new Array<string>(),
            component: ListDashboardLayoutsPage,
            children: {
                dashboardView: {
                    route: "/:dashboardLayoutId",
                    roles: [IT_ADMIN],
                    flavours: new Array<string>(),
                    component: ViewDashboardLayoutPage
                }
            }
        },
        resourceImageManager: {
            icon: "frame-expand.svg",
            name: i18n.t("resource-manager.resource-image-manager"),
            route: "/resource-image-manager",
            type: "link",
            exact: true,
            roles: [COMMERICAL, IT_ADMIN],
            flavours: new Array<string>(),
            component: ResourceImageManagerPage
        },
        content: {
            icon: "add-file.svg",
            name: i18n.t("targeting-content.content"),
            route: "/content",
            type: "link",
            exact: true,
            roles: [COMMERICAL, IT_ADMIN],
            flavours: new Array<string>(),
            component: ListContentPage,
            children: {
                contentView: {
                    route: "/:contentId",
                    roles: [IT_ADMIN, COMMERICAL],
                    flavours: new Array<string>(),
                    component: ViewContentPage
                }
            }
        },
        codedValues: {
            icon: "upload.svg",
            name: i18n.t("csv.coded-values"),
            route: "/coded-values",
            type: "link",
            exact: true,
            roles: [IT_ADMIN],
            flavours: new Array<string>(),
            component: ListCodedValues,
            // pageType: csvTypes.CODED_VALUES
        },
        financialCalendar: {
            icon: "calendar.svg",
            name: i18n.t("csv.financial-calendar"),
            route: "/financial-calendar",
            type: "link",
            exact: true,
            roles: [IT_ADMIN],
            flavours: new Array<string>(),
            component: CSVGenericPage,
            pageType: csvTypes.FINANCIAL_CALENDAR
        },
        outletLevelTarget: {
            icon: "money-protection.svg",
            name: i18n.t("csv.outlet-level-target"),
            route: "/outlet-level-target",
            type: "link",
            exact: true,
            roles: [IT_ADMIN],
            flavours: new Array<string>(),
            component: CSVGenericPage,
            pageType: csvTypes.OUTLET_TARGET
        },
        salesRouteTarget: {
            icon: "money-location.svg",
            name: i18n.t("csv.sales-route-target"),
            route: "/sales-route-target",
            type: "link",
            exact: true,
            roles: [IT_ADMIN],
            flavours: new Array<string>(),
            component: CSVGenericPage,
            pageType: csvTypes.ROUTE_TARGET
        },
        suppressionCodes: {
            icon: "na.svg",
            name: i18n.t("csv.suppression-codes"),
            route: "/suppression-codes",
            type: "link",
            exact: true,
            roles: [IT_ADMIN],
            flavours: new Array<string>(),
            component: CSVGenericPage,
            pageType: csvTypes.SUPPRESSION_CODES
        },
        customerPade: {
            icon: "customer.svg",
            name: i18n.t("csv.customer-pade"),
            route: "/customer-pade",
            type: "link",
            exact: true,
            roles: [IT_ADMIN],
            flavours: [SIMA, VN],
            component: CSVGenericPage,
            pageType: csvTypes.CUSTOMER_PADE
        },
        routePade: {
            icon: "stats-up.svg",
            name: i18n.t("csv.route-pade"),
            route: "/route-pade",
            type: "link",
            exact: true,
            roles: [IT_ADMIN],
            flavours: [SIMA, VN],
            component: CSVGenericPage,
            pageType: csvTypes.ROUTE_PADE
        },
        callCycle: {
            icon: "spinner-arrow.svg",
            name: i18n.t("csv.call-cycle"),
            route: "/call-cycle",
            type: "link",
            exact: true,
            roles: [IT_ADMIN],
            flavours: [PH, VN],
            component: CSVGenericPage,
            pageType: csvTypes.CALL_CYCLE
        },
        icExclusion: {
            icon: "cross-circle.svg",
            name: i18n.t("csv.ic-exclusion"),
            route: "/ic-exclusion",
            type: "link",
            exact: true,
            roles: [IT_ADMIN],
            flavours: [SIMA],
            component: CSVGenericPage,
            pageType: csvTypes.IC_EXCLUSION
        },
        categoryTarget: {
            icon: "target-revenue.svg",
            name: i18n.t("csv.category-target"),
            route: "/category-target",
            type: "link",
            exact: true,
            roles: [IT_ADMIN],
            flavours: new Array<string>(),
            component: CSVGenericPage,
            pageType: csvTypes.CATEGORY_TARGET
        },
        cdeTarget: {
            icon: "coin.svg",
            name: i18n.t("csv.cde-target"),
            route: "/cde-target",
            type: "link",
            exact: true,
            roles: [IT_ADMIN],
            flavours: new Array<string>(),
            component: CSVGenericPage,
            pageType: csvTypes.CDE_TARGET
        },
        biEgress: {
            icon: "share.svg",
            name: i18n.t("csv.bi-egress"),
            route: "/bi-egress",
            type: "link",
            exact: true,
            roles: [IT_ADMIN],
            flavours: new Array<string>(),
            component: CSVGenericPage,
            pageType: csvTypes.BI_EGRESS
        },
        callScheduleBlacklist: {
            icon: "radio-button.svg",
            name: i18n.t("call-schedule-blacklist.call-schedule-blacklist"),
            route: "/call-schedule-blacklist",
            type: "link",
            exact: true,
            roles: [IT_ADMIN],
            flavours: new Array<string>(),
            component: CallScheduleBlacklistPage
        },
        targetingHeader: {
            name: i18n.t("drawer-items.targeting"),
            type: "header",
            route: "targeting-header",
            roles: [COMMERICAL, IT_ADMIN],
            flavours: new Array<string>()
        },
        targetGroups: {
            icon: "target.svg",
            name: i18n.t("target-group.target-groups"),
            route: "/target-groups",
            type: "link",
            exact: true,
            roles: [COMMERICAL, IT_ADMIN],
            flavours: new Array<string>(),
            component: ListTargetGroupsPage,
            children: {
                targetGroupsNew: {
                    route: "/new",
                    exact: true,
                    roles: [IT_ADMIN, COMMERICAL],
                    flavours: new Array<string>(),
                    component: ViewTargetGroupsPage,
                    pageType: TargetGroupType.CREATE
                },
                targetGroupsView: {
                    route: "/:targetGroupId",
                    roles: [IT_ADMIN, COMMERICAL],
                    flavours: new Array<string>(),
                    component: ViewTargetGroupsPage,
                    pageType: TargetGroupType.VIEW
                }
            }
        },
        campaigns: {
            icon: "licencse.svg",
            name: i18n.t("campaign.campaigns"),
            route: "/campaigns",
            type: "link",
            exact: true,
            roles: [COMMERICAL, IT_ADMIN],
            flavours: new Array<string>(),
            component: ListCampaignsPage,
            children: {
                campaginsNew: {
                    route: "/new",
                    exact: true,
                    roles: [IT_ADMIN, COMMERICAL],
                    flavours: new Array<string>(),
                    component: CampaignsPage
                },
                campaginsView: {
                    route: "/:campaignId",
                    roles: [IT_ADMIN, COMMERICAL],
                    flavours: new Array<string>(),
                    component: ViewCampaignPage
                }
            }
        }
    })

    return config
}